/** Curated avatar emojis for trip members (picker grid). */
export const AVATAR_EMOJI_OPTIONS = [
  '👤', '👨', '👩', '🧑', '👦', '👧', '🧒', '👴', '👵',
  '🧔', '👱‍♀️', '🐻', '🦊', '🐼', '🦁', '🐯', '🐶', '🐱',
  '🌞', '🌙', '⭐', '🎒', '🧳', '🚗', '✈️', '🏔️', '🌊', '🍕', '☕', '🎉',
];

export const DEFAULT_AVATAR_EMOJI = '👤';
